export default {
  select_to_share: 'Selecionar contatos ou canais para compartilhar',
  forward: 'Encaminhar',
  cancel: 'Cancelar',
};
